import { GetSpacesApi } from "../../adapters/get-spaces";

export const useGetSpaces = () => {
  const { data } = GetSpacesApi();

  return {
    data,
  };
};
